// extracted by mini-css-extract-plugin
module.exports = {"content":"ScoringCode_content__RLPxB","code-form":"ScoringCode_code-form__bRLHC"};